<template>
  <div>
    <div class="d-flex justify-content-between mb-4">
      <div>
        <div class="section-title">{{ $tc("screen", 2) }}</div>
      </div>
      <div>
        <b-button v-if="
          cinema_manager_add_edit_disabled != 3 &&
          screens_full &&
          $can('create', 'Screens')
        " variant="default" to="/cinema-manager/add-screen" class="btn-blue">{{ $tc("add") }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex" style="gap: 10px">
        <div>
          <b-form-input v-debounce:300="onSearch" v-model="searchValue" placeholder="Search..."
            style="width: 200px"></b-form-input>
        </div>

        <div class="">
          <div class="dropdown-curve-container mr-2">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <b-dropdown :disabled="isRoleID" :text="selectedCinema" variant="dropdown-curve" style="width: 400px">
              <div class="px-2 pb-2">
                <input required autofocus type="search" placeholder="Search Cinema" class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)" v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)" v-model="searchCinema" />
              </div>
              <b-dropdown-item v-for="(dropdownItem, dropdownIndex) in cinemaList" :key="dropdownIndex" href="#"
                @click="onDropdownChange($event, dropdownItem)">{{ dropdownItem.cine_name }}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <div class="dropdown-curve-container ml-2">
          <b-dropdown :disabled="isRoleID" :text="selectedStatus" variant="dropdown-curve" style="width: 200px">
            <b-dropdown-item v-for="(dropdownItem, dropdownIndex) in status" :key="dropdownIndex" href="#"
              @click="onStatusChange(dropdownItem.value)">{{ dropdownItem.value }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex"
              @click="onDropDownChangeValue(list.name)">{{ list.name }}</b-dropdown-item>
          </b-dropdown>
        </div>

        <button v-if="GridViewFlag" class="btnj btn-gridView mr-3" :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"></button>
        <button v-if="GridViewFlag" class="btnj btn-listView" :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"></button>
      </div>
    </div>

    <div class="white-wrapper" style="padding: 10px 25px">
      <table class="list-view-table mt-1 mb-1" v-if="listView">
        <thead>
          <tr>
            <th class="text-left" style="width: 100px">
              <span class="">{{ $tc("status", 2) }}</span>
            </th>
            <th class="text-left" style="width: 100px">
              {{ $tc("Screen Id", 1) }}
            </th>
            <th style="width: 200px">
              <img v-if="this.columnName != 'screen_name'" @click="onSortValue('screen_name', 'asc')"
                src="@/assets/img/icons/updown.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else-if="isSort && isAscending" @click="onSortValue('screen_name', 'asc')"
                src="@/assets/img/icons/asc.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else @click="onSortValue('screen_name', 'desc')" src="@/assets/img/icons/desc.svg"
                class="cursor-pointer" width="15px" height="20px" />
              {{ $tc("screen", 1) }}
            </th>
            <th style="width: 70px">
              <img v-if="this.columnName != 'screen_order'" @click="onSortValue('screen_order', 'asc')"
                src="@/assets/img/icons/updown.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else-if="isSort && isAscending" @click="onSortValue('screen_order', 'asc')"
                src="@/assets/img/icons/asc.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else @click="onSortValue('screen_order', 'desc')" src="@/assets/img/icons/desc.svg"
                class="cursor-pointer" width="15px" height="20px" />
              {{ $tc("order", 1) }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="Screens.length > 0">
          <tr v-for="(item, key) in Screens" :key="key" class="light_grey_back">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot :status="item.screen_is_active ? 'active' : 'inactive'" />
                <span v-if="
                  cinema_manager_add_edit_disabled != 3 &&
                  $can('update', 'Screens')
                " class="edit-icon ml-4 blue-icon" @click="goToRoute('/cinema-manager/edit-screen', item)"
                  style="cursor: pointer" v-b-tooltip="'Edit'" tabindex="0">
                  <i class="edit-pen icon blue-icon"></i>
                </span>
                <span class="view-icon ml-2 blue-icon" @click="goToRoute('/cinema-manager/view-screen', item)"
                  style="cursor: pointer" v-b-tooltip="'View'" tabindex="0">
                  <i class="icon-eye icon blue-icon"></i>
                </span>
              </div>
            </td>

            <td class="text-center">{{ item.screen_id }}</td>
            <td>{{ item.screen_name }}</td>
            <td class="text-center">{{ item.screen_order }}</td>
            <td class="text-center">
              <!-- :to="'/cinema-manager/add-seat-layout/' + item.screen_id" -->
              <b-button v-if="!item.screen_layout_active" variant="default" class="btn-blue" @click.prevent.stop="
                OnAddSeatLayout('/cinema-manager/add-seat-layout/', item)
                ">{{ $t("add") }} {{ $t("seatlayout") }}</b-button>
            </td>
          </tr>
        </tbody>
        <tbody v-if="Screens.length === 0">
          <tr></tr>
          <tr>
            <td class="tetx-center" colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-pagination v-model="currentPage" :total-rows="rows" @change="onChangePagination($event)" :per-page="perPage"
      aria-controls="my-table"></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Screens from "@/helper/formJSONMaster/Screens";
import CinemasService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { encryptString } from "@/helper/collection"

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      status: [
        {
          value: "All",
        },
        {
          value: "Active",
        },
        {
          value: "Inactive",
        },
      ],
      screens_full: true,
      cinema_manager_add_edit_disabled: null,
      isRoleID: true,
      isRoleID1: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",

      getitem: "",
      isDisabled: false,
      gridView: false,
      listView: true,
      Methods: Screens.Methods,
      Screens: [],
      ScreensCopy: [],
      cinemaList: [],
      selectedCinema: "",
      selectedStatus: "Active",
      customErrors: {
        message: "",
      },
      SeatLayout: [],
      cinemaListCopy: [],
      searchCinema: "",

      debounce: null,
      searchValue: "",
      searchKey: "screen_name",
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "screen_order",
      orderBy: "asc",
    };
  },

  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    this.isRoleID1 = roleid;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    this.getviewingnumber();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.selectedid = CinemaObj;
      this.getScreensList(CinemaObj);
    }
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onSortValue(columnName, orderBy) {
      if (this.selectedCinema.length == 0) {
        return this.$toasted.show("Please select cinema");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getScreensList(this.selectedid);
    },
    onSearch: function () {
      this.getScreensList(this.selectedid);
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemaList = this.cinemaListCopy.filter((x) => {
          if (
            x.cine_name
              .toLowerCase()
              .includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemaList = this.cinemaListCopy;
      }
    },
    OnAddSeatLayout: function (path, item) {
      let array = this.Screens.filter((x) => {
        if (x.screen_id != item.screen_id) {
          if (
            x.screen_name === item.screen_name &&
            x.screen_is_active == true &&
            item.screen_is_active == false
          ) {
            return x.screen_name === item.screen_name;
          } else if (
            x.screen_name === item.screen_name &&
            x.screen_is_active == false &&
            item.screen_is_active == false
          ) {
            return x.screen_name === item.screen_name;
          } else {
            return;
          }
        }
      });
      if (array.length >= 1) {
        this.$toasted.show(
          "Please inactive existing active screen before adding seat layout"
        );
        return;
      } else if (array.length == 0) {
        const { screen_id, cinema_id } = item;
        this.$router.push({
          path: path + screen_id,
          query: {
            cinema_id: encryptString(String(cinema_id))
          }
        });
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getScreensList(this.selectedid);
      } else if (this.isRoleID1 != 1) {
        this.currentPage = event;
        this.getScreensList(this.selectedid);
      } else {
        this.currentPage = event;
        this.getScreensList(this.selectedid);
      }
    },
    onStatusChange: function (value) {
      this.Screens = this.ScreensCopy;
      this.selectedStatus = value;
      this.getScreensList(this.selectedid);
      // if (value == "Active") {
      //   this.getScreensList(value);
      //   // this.Screens = this.Screens.filter((x) => x.screen_is_active);
      // } else if (value == "Inactive") {
      //   this.Screens;
      //   // this.Screens = this.Screens.filter((x) => !x.screen_is_active);
      // } else {
      //   this.Screens;
      //   // this.Screens = this.ScreensCopy;
      // }
    },
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.selectedid = {
        cine_id: item.cine_id,
      };
      this.getScreensList(item);
      this.searchCinema = "";
      this.onSearchCinema(null);
      this.$store.dispatch("selectDropdownCinema", item);
    },

    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // console.log("data :", data);
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;
            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                this.selectedid = x;
                let item = {
                  cine_id: x.cine_id,
                };

                this.getitem = item;
                this.getScreensList(item);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    /* eslint-disable */
    goToRoute: function (path, item) {
      const { screen_id, cinema_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: screen_id,
          cinema_id: encryptString(String(cinema_id))
        },
      });
    },
    getScreensList: function (item) {
      console.log(item, "itemmmm");
      if(!item['cine_id']){
        return this.$toasted.show("Please select cinema")
      }
      this.Screens = [];
      let body = {
        tableName: "screens",
        activekey: "screen_is_active",
        conditionColName: "cinema_id",
        conditionId: item.cine_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        searchKey: this.searchKey,
        columnName: this.columnName,
        orderBy: this.orderBy,
        status: this.selectedStatus,
      };

      CinemasService.GetActiveScreenByCinema(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Screens = data.Records;
            this.ScreensCopy = data.Records;
            this.Screens.length >= item.cine_screens
              ? (this.screens_full = false)
              : (this.screens_full = true);
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue = this.perPage;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemasScreenComponents/cinemaScreens.vue